<input type="text" ngxDaterangepickerMd [(ngModel)]="selected" placeholder="Choose date" 
    (change)="dateChange($event)" [ranges]="ranges" [alwaysShowCalendars]="true" 
    [customRangeDirection]="true" [locale]="locale" [isInvalidDate]="isInvalidDate" 
    [value]="inputValue" class="custom__field" class="custom__field" />
